export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9818.e929af21.jpg";